export enum ChangeForgotPasswordFormField {
  Password = 'password',
  PasswordConfirmation = 'passwordConfirmation',
}
